module.exports = __webpack_public_path__ + "img/bg_black.ba1bdf09.png";